import { render } from "./BankTransfer.vue?vue&type=template&id=3af01eaa&scoped=true&ts=true"
import script from "./BankTransfer.vue?vue&type=script&lang=ts"
export * from "./BankTransfer.vue?vue&type=script&lang=ts"

import "./BankTransfer.vue?vue&type=style&index=0&id=3af01eaa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af01eaa"]])

export default __exports__